<template>
  <div class="slideout-header">
    <div class="left-options">
      <div class="title">{{ title }}</div>
      <div class="tabs-container">
        <Tabs
          id="demographics-tabs"
          :tabs="displayTabs"
          :currentTab="currentTab"
          @click="handleTabClick"
        ></Tabs>
      </div>
    </div>
    <div class="right-options">
      <SecondaryButton
        class="button"
        @click="cancel">
          Cancel
      </SecondaryButton>
      <PrimaryButton
        class="save button"
        :disabled="inactiveSave"
        @click="save">
          Save
      </PrimaryButton>
    </div>
  </div>
</template>

<script>
import { Tabs, PrimaryButton, SecondaryButton } from '@mikmak/components';

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    currentTabIndex: {
      type: Number,
      default: 0,
      validator: val => val >= 0 && val <= 1,
    },
    displayTabs: {
      type: Array,
      required: true,
    },
    canSave: {
      type: Boolean,
    },
  },
  computed: {
    currentTab() {
      return this.displayTabs[this.currentTabIndex];
    },
    inactiveSave() {
      return !this.canSave;
    },
  },
  components: {
    Tabs,
    PrimaryButton,
    SecondaryButton,
  },
  methods: {
    handleTabClick(tab) {
      const index = this.displayTabs.indexOf(tab);

      this.$emit('handleTabClick', index);
    },
    save() {
      this.$emit('complete');
    },
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style lang="scss" scoped>
.slideout-header {
  z-index: 3;
  position: sticky;
  width: 100%;
  height: 76px;
  left: 0px;
  top: 0px;
  background: #FFFFFF;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.left-options {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding-left: 16px;
    .title {
      padding-right: 39px;
      font-size: 24px;
    }
    .tabs-container {
      padding-top: 10px;
    }
}
.right-options {
  display: flex;
  align-items: center;
  padding-right: 14px;
}
::v-deep {
  & .main-button.secondary,
  & .main-button.secondary:hover,
  & .main-button.secondary.focused {
    border: 1px solid #223448 !important;
    color: #223448 !important;
    background-color: #FFFFFF !important;
  }
}
</style>
